import styled, { css } from 'styled-components';

import RichText, { RichTextProps } from 'components/RichText/RichText';
import { setTypography } from 'utils/styles/mixins';
import { colors, layout } from 'utils/styles/theme';

const { min } = layout.columns;

interface WrapperProps {
  hoverTextColor?: string;
}

interface EmailsProps {
  $isMargin?: boolean;
}

export const Wrapper = styled.div<WrapperProps>`
  width: fit-content;
  display: grid;
  grid-template-columns: repeat(${min}, 1fr);
  grid-gap: 56px;

  margin-top: 42px;
  grid-column: 1 / -1;

  & > div {
    min-width: 212px;
  }

  address {
    width: 299px;
  }

  ${({ hoverTextColor }) =>
    hoverTextColor?.length &&
    css`
      & div span:hover,
      & div a:hover {
        color: ${colors[hoverTextColor] ?? hoverTextColor};
        text-decoration: underline;
        cursor: pointer;
      }
    `}
`;

export const GlobalContainer = styled.address`
  min-width: 212px;

  div {
    display: grid;
  }
`;

export const TextRich = styled(RichText)<RichTextProps & EmailsProps>`
  ${({ theme: { locale } }) => setTypography('small', locale)};
  ${({ $isMargin }) => $isMargin && 'margin-top: 23px'};
`;

export const Emails = styled.div<EmailsProps>`
  ${({ $isMargin }) => !$isMargin && 'margin-top: 23px'};
`;

export const Container = styled.div`
  margin-top: 10px;

  a[target='_blank'] {
    text-decoration: underline;
  }
`;

export const SocialsContainer = styled.section`
  margin: 8px 0 0;
`;
